import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authenticationSlices';
import serviceRefReducer from './reducers/security/serviceRefSlices';
import userAccReducer from './reducers/security/userAccountMgmtSlice';
import userGroupReducer from './reducers/security/userGroupSlices';
import userRoleReducer from './reducers/security/userRoleSlices';
import profileReducer from './reducers/userProfileSlice';
import ProjectReducer from './reducers/project-slices/ProjectSlices';
import ProjectSettingReducer from './reducers/project-slices/ProjectSettingSlice';
import GeneralSettingReducer from './reducers/configurationSetting-slices/GeneralSettingSlice'
import ProjectConfigReducer from './reducers/configurationSetting-slices/ProjectConfigSlice'
import uploadReducer from './actions/uploadFile';
import downloadReducer from './actions/downloadFile';
import CompanyProfileReducer from './reducers/CompanyProfileSlice';
import documentManagerReducer from './reducers/DocumentManagerSlice';
const store = configureStore({
    reducer:{
        auth: authReducer,
        userPrf:profileReducer,
        //upload
        upload: uploadReducer,
        //download
        download: downloadReducer,
        //prj
        project:ProjectReducer,
        projectSetting: ProjectSettingReducer,
        // configurationSetting
        generalSetting: GeneralSettingReducer,
        projectConfig: ProjectConfigReducer, 
        // company profile 
        companyProfile: CompanyProfileReducer,
        // document manager 
        documentManager: documentManagerReducer,
        //entitlement
        userAccMgmt:userAccReducer,
        userGroup:userGroupReducer,
        serviceRef:serviceRefReducer,
        userRole:userRoleReducer
    }
});

export default store;